import React, { FC } from 'react';
import { MainLayout } from '../layouts/MainLayout';
import { DashboardComponent } from '../components/dashboard/DashboardComponent';
import { WelcomeWidget } from '../components/widget/WelcomeWidget';

export const Dashboard: FC = () => (
  <MainLayout selectedTab="DASHBOARD">
    <WelcomeWidget />
    <DashboardComponent />
  </MainLayout>
);
